import React from "react"
import { withRouter } from "react-router-dom"
import queryString from "query-string"
import { useSelector, useDispatch } from "react-redux"
import UserFieldEditorFooter from "../UserFieldEditorFooter/UserFieldEditorFooter"
import { WithDrawerConsumer } from "../../Contexts/DrawerContext/withDrawerConsumer"
import constants from "../../Constants"
import { profileSteps } from "../../Redux/Reducers/Application/profileMetadata"
import { spouseProfileSteps } from "../../Redux/Reducers/SpouseApplication/spouseProfileMetadata"
import Actions from "../../Redux/Actions"
import { allFormsFilled } from "../../Redux/Utils/reducerUtils"

const ProfileFooter = (props) => {
  const dispatch = useDispatch()

  const reduxStateData = useSelector(({ user, application }) => ({
    currentInputData: application.currentInputData,
    profileMetadata: (user.user.is_spouse === 0 || user.user.is_spouse === 2 || user.user.is_spouse === 3) ? application.profileMetadata : spouseProfileSteps,
    user: user.user,
    willLocate: application.userWillReLocate
  }))

  const getNextPage = () => {
    const pageTitle = queryString.parse(props.history.location.search).title
    const currentPageIndex = (reduxStateData.user.is_spouse === 0 || reduxStateData.user.is_spouse === 2 || reduxStateData.user.is_spouse === 3) ? profileSteps.findIndex(
      (elem) => elem.stepId === pageTitle
    ) :
    spouseProfileSteps.findIndex(
      (elem) => elem.stepId === pageTitle
    )
/*
    if (pageTitle === "location") {
      if (reduxStateData.willLocate) {
        return profileSteps[currentPageIndex + 1].url
      }
      return profileSteps[currentPageIndex + 2].url
    }*/
    if (reduxStateData.user.is_spouse === 0 || reduxStateData.user.is_spouse === 2 || reduxStateData.user.is_spouse === 3) {
      return profileSteps[currentPageIndex + 1].url
    } else {
      return spouseProfileSteps[currentPageIndex + 1].url
    }
  }

  const getPreviousPage = () => {
    const pageTitle = queryString.parse(props.history.location.search).title

    const currentPageIndex = (reduxStateData.user.is_spouse === 0 || reduxStateData.user.is_spouse === 2 || reduxStateData.user.is_spouse === 3) ? profileSteps.findIndex(
      (elem) => elem.stepId === pageTitle
    ) : spouseProfileSteps.findIndex(
      (elem) => elem.stepId === pageTitle
    )

    if (pageTitle === "military") {
      if (reduxStateData.willLocate) {
        return profileSteps[currentPageIndex - 1].url
      }
      return profileSteps[currentPageIndex - 2].url
    }
    if (reduxStateData.user.is_spouse === 0 || reduxStateData.user.is_spouse === 2 || reduxStateData.user.is_spouse === 3) {
      return profileSteps[currentPageIndex - 1].url
    } else {
      return spouseProfileSteps[currentPageIndex - 1].url
    }
  }

  const nextHandler = async () => {
    const pageTitle = queryString.parse(props.history.location.search).title
    const isProfilePage = window.location.href.includes('/profile')
    const last_page_check = reduxStateData.user.is_spouse === 1
    ? constants.SPOUSE_PROFILE_LAST_PAGE
    : constants.PROFILE_LAST_PAGE;

    if (pageTitle !== last_page_check) {
      if (reduxStateData.currentInputData) {
        try {
          if (isProfilePage) {
            // For profile pages, save user data and wait for completion
            await dispatch(Actions.setUserInputData(reduxStateData.currentInputData, props.history))
          } else {
            // For application pages, save application data and wait for completion
            await dispatch(
              Actions.saveApplication(
                reduxStateData.currentInputData,
                props.history
              )
            )
          }
          dispatch(Actions.toggleUnfilled())
        } catch (error) {
          console.error('Error saving data:', error)
          // Continue navigation even if save fails
        }
      }
      // Navigate after save completes (or if no data to save)
      props.history.push(getNextPage())
    } else if (allFormsFilled(reduxStateData.profileMetadata)) {
      if (reduxStateData.currentInputData) {
        try {
          if (isProfilePage) {
            // For profile pages, save user data
            await dispatch(Actions.setUserInputData(reduxStateData.currentInputData, props.history))
          } else {
            // For application pages, save application data
            await dispatch(
              Actions.saveApplication(
                reduxStateData.currentInputData,
                props.history,
                "/home"
              )
            )
          }
        } catch (error) {
          console.error('Error saving data:', error)
        }
      }
      props.history.push("/home")
    } else {
      try {
        if (isProfilePage) {
          // For profile pages, save user data
          await dispatch(Actions.setUserInputData(reduxStateData.currentInputData, props.history))
        } else {
          // For application pages, save application data
          await dispatch(
            Actions.saveApplication(reduxStateData.currentInputData, props.history)
          )
        }
      } catch (error) {
        console.error('Error saving data:', error)
      }
      dispatch(Actions.toggleUnfilled())
      props.openDrawerAndPreventTertiary()
    }
  }

  const previousHandler = async () => {
    const pageTitle = queryString.parse(props.history.location.search).title
    const isProfilePage = window.location.href.includes('/profile')
    if (pageTitle !== constants.PROFILE_FIRST_PAGE) {
      if (reduxStateData.currentInputData) {
        try {
          if (isProfilePage) {
            // For profile pages, save user data and wait for completion
            await dispatch(Actions.setUserInputData(reduxStateData.currentInputData, props.history))
          } else {
            // For application pages, save application data and wait for completion
            await dispatch(
              Actions.saveApplication(
                reduxStateData.currentInputData,
                props.history
              )
            )
          }
        } catch (error) {
          console.error('Error saving data:', error)
          // Continue navigation even if save fails
        }
      }
      // Navigate after save completes (or if no data to save)
      props.history.push(getPreviousPage())
    }
  }

  const last_page = (reduxStateData.user.is_spouse === 0 || reduxStateData.user.is_spouse === 2 || reduxStateData.user.is_spouse === 3) ? constants.PROFILE_LAST_PAGE : constants.SPOUSE_PROFILE_LAST_PAGE

  const saveAndExitHandler = (checkSubmittability, inputData) => async () => {
    const isProfilePage = window.location.href.includes('/profile')
    try {
      if (inputData) {
        if (isProfilePage) {
          // For profile pages, save user data
          await dispatch(Actions.setUserInputData(inputData, props.history))
        } else {
          // For application pages, save application data
          await props.saveApplication(inputData, props.history)
        }
        dispatch(Actions.toggleHasCheckedProfile(true))
      }

      if (props.user.has_submitted_application) {
        props.history.push("/home")
      } else {
        props.logout()
        props.history.push("/account/login")
      }
    } catch (error) {
      console.error("Error saving application:", error)
      // Still allow navigation even if save fails
      if (props.user.has_submitted_application) {
        props.history.push("/home")
      } else {
        props.logout()
        props.history.push("/account/login")
      }
    } finally {
      props.closeAllDrawers()
    }
  }

  const pageTitle = queryString.parse(props.history.location.search).title

  return (
    <UserFieldEditorFooter
      nextHandler={nextHandler}
      previousHandler={previousHandler}
      renderPreviousButton={pageTitle !== constants.PROFILE_FIRST_PAGE}
      saveAndExitHandler={saveAndExitHandler}
      toRenderSaveAndExitButton={!reduxStateData.user.has_submitted_application}
      nextText={
        pageTitle === last_page ? "Finish Editing" : "Next"
      }
    />
  )
}

export default withRouter(WithDrawerConsumer(ProfileFooter))
